import { BaseCategory } from "./BaseCategory";
import { DecorationStyle, ElementTextBlockPositionType, HeaderPositionType, PaletteColorType, TextStyleType } from "../constants";
import { SlideCategories } from "./CategoryController";
import { SlideModelBuilder } from "./SlideModelBuilder";

export class FunnelCategory extends BaseCategory {
    get name() {
        return "Funnel";
    }

    get type() {
        return SlideCategories.FUNNEL;
    }

    get icon() {
        return null;
    }

    get description() {
        return `The content describes a hierarchical structure, progression, or filtering process. Use for pyramid and funnel diagrams.`;
    }

    get slideTypes() {
        return [];
    }

    getPrompt() {
        return `Parse the content to determine what to consider as items in the funnel/pyramid and list those items in order. Separate any additional content into the conclusion`;
    }

    getImagePrompt() {
        return false;
    }

    getModelHints() {
        return {
            funnelType: "pyramid | funnel",
        };
    }

    getPromptSchema(options = {}) {
        return {
            items: this.getItemListSchema(options),
            conclusion: "an optional short conclusion or takeaway for the slide",
        };
    }

    validateGeneratedModel(model) {
        if (!this.validateArray(model.items)) {
            return false;
        }
        return true;
    }

    getSlideModels(model) {
        return this.buildModels([
            this.buildPyramid(model),
            this.buildInvertedPyramid(model),
            this.buildStepPyramid(model),
        ]);
    }

    buildPyramid(model) {
        let builder = new SlideModelBuilder("pyramid", model, model.hints?.funnelType === "pyramid");
        builder.createHeader({ heading: model.slideTitle, position: HeaderPositionType.TOP });

        let primary = {
            collectionColor: "colorful",
            baseSize: 47,
            capSize: 5,
            capAlign: "center",
            decorationStyle: DecorationStyle.FILLED,
            inverted: false,
            step: false,
            showDescriptions: true,
            items: model.items.map(item => ({
                text: {
                    blocks: [
                        builder.createBlock(item.title, TextStyleType.TITLE),
                        builder.createBlock(item.description, TextStyleType.BODY),
                    ]
                }
            })),
        };

        builder.createPrimary(primary);

        if (model.conclusion) {
            builder.createBottomTray(model.conclusion, ElementTextBlockPositionType.TRAY);
        }
        return builder;
    }

    buildInvertedPyramid(model) {
        let builder = new SlideModelBuilder("pyramid", model, model.hints?.funnelType === "funnel");
        builder.createHeader({ heading: model.slideTitle, position: HeaderPositionType.TOP });

        let primary = {
            collectionColor: "colorful",
            baseSize: 47,
            capSize: 5,
            capAlign: "center",
            decorationStyle: DecorationStyle.FILLED,
            inverted: true,
            step: false,
            showDescriptions: true,
            items: model.items.map(item => ({
                text: {
                    blocks: [
                        builder.createBlock(item.title, TextStyleType.TITLE),
                        builder.createBlock(item.description, TextStyleType.BODY),
                    ]
                }
            })),
        };

        builder.createPrimary(primary);

        if (model.conclusion) {
            builder.createBottomTray(model.conclusion, ElementTextBlockPositionType.TRAY);
        }
        return builder;
    }

    buildStepPyramid(model) {
        let builder = new SlideModelBuilder("pyramid", model, model.hints?.funnelType === "pyramid");
        builder.createHeader({ heading: model.slideTitle, position: HeaderPositionType.TOP });

        let primary = {
            collectionColor: "theme-to-dark",
            baseSize: 47,
            capSize: 5,
            capAlign: "left",
            decorationStyle: DecorationStyle.FILLED,
            inverted: false,
            step: true,
            showDescriptions: true,
            items: model.items.map(item => ({
                text: {
                    blocks: [
                        builder.createBlock(item.title, TextStyleType.TITLE),
                        builder.createBlock(item.description, TextStyleType.BODY),
                    ]
                }
            })),
        };

        builder.createPrimary(primary);

        if (model.conclusion) {
            builder.createBottomTray(model.conclusion, ElementTextBlockPositionType.TRAY);
        }
        return builder;
    }

    buildStepFunnel(model) {
        let builder = new SlideModelBuilder("pyramid", model, model.hints?.funnelType === "funnel");
        builder.createHeader({ heading: model.slideTitle, position: HeaderPositionType.TOP });

        let primary = {
            collectionColor: "theme-to-dark",
            baseSize: 47,
            capSize: 5,
            capAlign: "left",
            decorationStyle: DecorationStyle.FILLED,
            inverted: true,
            step: true,
            showDescriptions: true,
            items: model.items.map(item => ({
                text: {
                    blocks: [
                        builder.createBlock(item.title, TextStyleType.TITLE),
                        builder.createBlock(item.description, TextStyleType.BODY),
                    ]
                }
            })),
        };

        builder.createPrimary(primary);

        if (model.conclusion) {
            builder.createBottomTray(model.conclusion, ElementTextBlockPositionType.TRAY);
        }
        return builder;
    }
}
